import { Filter, FilterType, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';

const key = FilterKey.UNIVERSITY;
export const getUniversityFilter = ({
  activeFilters,
  userRole,
  isPathway,
  filterOptions,
}: IGetFilterGroupsProps): Filter | null => {
  const role = userRole || UserRole.Unknown;
  const isPathwayUniUser =
    isPathway && [UserRole.Uni, UserRole.UniAdmin, UserRole.UniSecure, UserRole.UniLite].includes(role);
  const canFilterUniversity = isPathwayUniUser || hasPerm(role, P.FILTER_UNIVERSITY);
  if (!canFilterUniversity) {
    return null;
  }

  const uniFilterOptions = filterOptions?.uni ?? [];

  const filters = activeFilters[key] ?? [];
  const options = uniFilterOptions.map(uni => {
    return {
      label: uni.label,
      value: uni.value,
      checked: filters.some(filter => filter === uni.value),
    };
  });
  return {
    name: 'University',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: options,
    },
  };
};
